import { useLayer } from '@statsig/react-bindings';

import { ExperimentLayers } from '../../statsig/experiments';

export function useFollowUpNudgeExperiment(isFollowUpAppointment: boolean) {
  const [layerName, { shouldSeeFollowUpNudge }] = ExperimentLayers.FollowUpScheduling;
  const layer = useLayer(layerName);

  // Reading the param logs the exposure, so only read it for sessions that are part of the experiment.
  return isFollowUpAppointment && (layer.get<boolean>(shouldSeeFollowUpNudge, false) ?? false);
}
